// @section: lib-data
export const ROUTE_PATHS = { HOME: '/' } as const;

export const CHAPTERS = [
  { id: 1,  icon: '🎯', title: 'Prospección de Clientes',        color: 'gold'  },
  { id: 2,  icon: '💬', title: 'Atención por WhatsApp',          color: 'cyan'  },
  { id: 3,  icon: '📋', title: 'Cotizaciones y Propuestas',      color: 'gold'  },
  { id: 4,  icon: '🤝', title: 'Cierre de Ventas',               color: 'cyan'  },
  { id: 5,  icon: '🛡️', title: 'Manejo de Objeciones',           color: 'gold'  },
  { id: 6,  icon: '⬆️', title: 'Upselling y Cross-selling',      color: 'cyan'  },
  { id: 7,  icon: '🏆', title: 'Postventa y Fidelización',       color: 'gold'  },
  { id: 8,  icon: '📱', title: 'Contenido para Redes Sociales',  color: 'cyan'  },
  { id: 9,  icon: '📣', title: 'Campañas Promocionales',         color: 'gold'  },
  { id: 10, icon: '💼', title: 'Viajes Corporativos',            color: 'cyan'  },
  { id: 11, icon: '👥', title: 'Viajes en Grupo',                color: 'gold'  },
  { id: 12, icon: '💎', title: 'Turismo de Lujo',                color: 'cyan'  },
  { id: 13, icon: '👨‍👩‍👧', title: 'Turismo Familiar',             color: 'gold'  },
  { id: 14, icon: '💍', title: 'Lunas de Miel',                  color: 'cyan'  },
  { id: 15, icon: '🚢', title: 'Cruceros',                       color: 'gold'  },
  { id: 16, icon: '🌍', title: 'Destinos Internacionales',       color: 'cyan'  },
  { id: 17, icon: '🚨', title: 'Manejo de Crisis',               color: 'gold'  },
  { id: 18, icon: '🤔', title: 'Clientes Indecisos',             color: 'cyan'  },
  { id: 19, icon: '⚙️', title: 'Productividad Interna',          color: 'gold'  },
  { id: 20, icon: '🧠', title: 'IA Avanzada y Estrategia',       color: 'cyan'  },
];

export const BENEFITS = [
  { metric: '+3h',  label: 'ahorradas por día en redacción y seguimientos' },
  { metric: '2.8×', label: 'más conversiones en tus cotizaciones con clientes' },
  { metric: '100',  label: 'prompts listos para usar, sin curva de aprendizaje' },
  { metric: '20',   label: 'categorías del ciclo completo de ventas turísticas' },
];

export const FAQS = [
  {
    q: '¿Necesito saber programar o tener conocimientos técnicos?',
    a: 'No. Cada prompt está redactado en lenguaje natural. Solo copias, pegas en ChatGPT o cualquier IA y personalizas las variables entre corchetes. Cero código, cero tecnicismos.',
  },
  {
    q: '¿Funciona con la versión gratuita de ChatGPT?',
    a: 'Sí. Todos los prompts funcionan con ChatGPT 3.5 (gratuito) y obtienen resultados aún mejores con GPT-4 o Claude. No necesitas pagar por IA premium para arrancar.',
  },
  {
    q: '¿Qué diferencia a este ebook de los prompts genéricos de internet?',
    a: 'Estos prompts fueron diseñados exclusivamente para el sector turístico latinoamericano: manejo de objeciones típicas de la región, tarifas en USD/COP, destinos populares, temporadas y dinámicas de compra locales.',
  },
  {
    q: '¿Los prompts sirven para agencias pequeñas o freelancers?',
    a: 'Perfectamente. Fueron diseñados pensando en el agente independiente y la agencia boutique que necesita máxima eficiencia con recursos limitados. Aplican desde el día 1, sin infraestructura especial.',
  },
  {
    q: '¿Cómo recibo el ebook después de registrarme?',
    a: 'Inmediatamente después de completar el formulario recibirás acceso para descargarlo en formato PDF de alta resolución, optimizado para leer en pantalla y también imprimible.',
  },
  {
    q: '¿Incluye actualizaciones futuras del ebook?',
    a: 'Sí. Al registrarte quedas en nuestra lista de actualización. Cada vez que lancemos una nueva edición con prompts adicionales, te avisamos directamente a tu correo.',
  },
  {
    q: '¿Puedo compartir el ebook con mi equipo de ventas?',
    a: 'Puedes usarlo libremente dentro de tu agencia o equipo. Para distribución comercial contáctanos a info@consultor-ia.co para acordar los términos.',
  },
];

export const PROMPT_EXAMPLES = [
  {
    category: 'Descripción de Destinos',
    number: '01',
    title: 'La Experiencia Sensorial',
    prompt: `Actúa como copywriter de viajes de lujo con 15 años de experiencia. 
Describe [DESTINO] en 3 párrafos emocionalmente evocadores para [TIPO_CLIENTE]. 
Incluye: gastronomía local, mejor época del año y experiencia diferencial única. 
Tono: sofisticado pero accesible. Idioma: español colombiano.`,
    result: 'Textos de venta 3× más persuasivos que las descripciones genéricas de proveedor.',
  },
  {
    category: 'Manejo de Objeciones',
    number: '27',
    title: "El Neutralizador de 'Está muy caro'",
    prompt: `Cliente potencial dice: "Lo vi más barato en [PLATAFORMA_ONLINE]". 
Redacta 3 respuestas de WhatsApp que: (1) validen su preocupación, 
(2) expliquen el valor diferencial de tu agencia, 
(3) incluyan una llamada a la acción sin presión. 
Tono: empático y profesional, máximo 80 palabras cada respuesta.`,
    result: 'Recupera hasta el 40% de leads que parecían perdidos por precio.',
  },
  {
    category: 'Email Marketing',
    number: '68',
    title: 'La Secuencia de Re-enganche',
    prompt: `Escribe un email de seguimiento para [NOMBRE_CLIENTE] que cotizó [DESTINO] 
hace [N_DÍAS] días y no ha respondido. 
Incluye: línea de asunto con curiosidad, recordatorio del valor, 
beneficio exclusivo de urgencia y CTA suave. Máximo 150 palabras.`,
    result: 'Reactiva el 25-35% de prospectos inactivos en tu pipeline de ventas.',
  },
  {
    category: 'Contenido para Redes',
    number: '45',
    title: 'El Post de Prueba Social',
    prompt: `Transforma este testimonio real de cliente: [TESTIMONIO_RAW] 
en un post para Instagram de máximo 5 líneas. 
Incluye: gancho emocional, transformación del cliente, 
hashtags turísticos colombianos relevantes y emoji estratégico.`,
    result: 'Posts que generan 4-6× más guardados e interacciones que el contenido estándar.',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Sandra Morales',
    role: 'Agente independiente',
    city: 'Medellín',
    text: 'Antes tardaba 2 horas en armar una propuesta. Ahora son 15 minutos y el cliente queda impresionado. Este ebook cambió mi flujo de trabajo completamente.',
    stars: 5,
  },
  {
    name: 'Carlos Jiménez',
    role: 'Director comercial',
    city: 'Bogotá',
    text: 'Lo que más me sorprendió fue el módulo de manejo de objeciones. Mis asesores lo usan todos los días y cerramos 30% más negocios este trimestre.',
    stars: 5,
  },
  {
    name: 'Paola Ríos',
    role: 'Agencia boutique',
    city: 'Cali',
    text: 'Pensé que era otro ebook genérico de IA. Para nada. Cada prompt está adaptado a nuestra industria y al cliente latinoamericano. Vale cada minuto invertido.',
    stars: 5,
  },
];

export const LEARNS = [
  { icon: '⚡', title: 'Responder cotizaciones en minutos',        desc: 'No en horas. Con estructura persuasiva lista para enviar.' },
  { icon: '🛡️', title: 'Neutralizar cualquier objeción',           desc: "Con respuestas empáticas que convierten el 'está caro' en '¿cuándo salimos?'" },
  { icon: '📱', title: 'Crear contenido de redes en segundos',     desc: 'Posts, stories y copys que generan interacción real.' },
  { icon: '✉️', title: 'Construir secuencias de email que venden', desc: 'Seguimientos automáticos que reactivan prospectos inactivos.' },
  { icon: '💰', title: 'Posicionar tu valor por encima del precio', desc: 'Argumentos que eliminan la comparación de precio con OTAs.' },
  { icon: '🎯', title: 'Personalizar la experiencia de cada cliente', desc: 'Itinerarios y propuestas que hacen sentir al cliente único.' },
];

export const FOR_WHO = {
  yes: [
    'Agentes de viajes independientes',
    'Directores comerciales de agencias',
    'Asesores con pipeline de ventas activo',
    'Agencias boutique y DMCs',
    'Operadores turísticos con equipo de ventas',
    'Profesionales que ya usan ChatGPT pero quieren más resultados',
  ],
  no: [
    'Quienes buscan resultados sin practicar los prompts',
    'Agencias con procesos ya 100% automatizados',
    'Personas sin disposición para personalizar las variables',
  ],
};

export function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}
